<script>
  import ValidationMessage from '../../../../components/form/ValidationMessage.vue'
  import * as restfulService from '../../../../services/restfulService'
  import * as notifyService from '../../../../services/notifyService'
  import DataService from '../../../../services/dataService'
  import bus from '@utils/bus'
  import {required} from 'vuelidate/lib/validators'
  import helpers from '@mixins/helper'
  import {cloneDeep, find} from 'lodash'

  const defaultEvaluation = {
    id: '',
    event_paper_type_id: '',
    evaluation_type_id: '',
    start_datetime: '',
    end_datetime: '',
    min_evaluations_number: 0,
    min_evaluation_next_step: 0,
    evaluation_type: {id: '', name: ''},
    criterias: []
  }

  export default {
    name: 'event-evaluations',
    components: {ValidationMessage},
    mixins: [helpers],
    data () {
      return {
        isSubmitted: false,
        isLoadingData: true,
        activePaperType: 'tab',
        modalEvaluationVisible: false,
        evaluationSelect: '',
        eventPaperTypes: [],
        dependencies: {
          evaluation_types: [],
          criterias: []
        },
        event: {id: ''},
        evaluation: cloneDeep(defaultEvaluation)
      }
    },
    validations: {
      evaluation: {
        start_datetime: {required},
        end_datetime: {required},
        min_evaluations_number: {required},
        min_evaluation_next_step: {required}
      }
    },
    mounted () {
      this.getDependencies().then(_ => {
        const id = this.$route.params.id || null
        this.loadData(id)
      })
    },
    methods: {
      getDependencies () {
        return new Promise((resolve) => {
          DataService.get([{domain: 'evaluation_type'}, {domain: 'criteria'}]).then((result) => {
            this.dependencies = result
            resolve()
          })
        })
      },
      loadData (id) {
        bus.$emit('show-loader')
        if (id) {
          this.isEdit = true
          restfulService.get('event', null, id, null, [
            'paper_types.paper_type',
            'paper_types.evaluation_types.evaluation_type',
            'paper_types.evaluation_types.criterias.criteria'
          ])
            .then(response => {
              this.event.id = response.id
              this.eventPaperTypes = response.paper_types
              this.activePaperType = 'tab_' + response.paper_types[0].id
              this.isLoadingData = false
              bus.$emit('hide-loader')
            })
            .catch(e => {
              console.log(e)
              bus.$emit('hide-loader')
              this.isLoadingData = false
            })
        } else {
          bus.$emit('hide-loader')
          this.isLoadingData = false
        }
      },
      checkEvaluationSelected (id, index) {
        return this.eventPaperTypes[index].evaluation_types.some(item => item.evaluation_type_id === id)
      },
      selectEvaluation (evaluationSelect, index) {
        if (evaluationSelect && evaluationSelect !== '') {
          const hasEvaluation = this.eventPaperTypes[index].evaluation_types.some(item => item.evaluation_type_id === evaluationSelect)
          if (!hasEvaluation) {
            const data = cloneDeep(defaultEvaluation)
            data.evaluation_type = find(this.dependencies.evaluation_types, item => item.id === evaluationSelect)
            data.evaluation_type_id = data.evaluation_type.id
            data.event_paper_type_id = this.eventPaperTypes[index].id
            this.saveEvaluation(data)
              .then(response => {
                data.id = response.id
                this.eventPaperTypes[index].evaluation_types.push(data)
                this.evaluationSelect = ''
                this.editEvaluation(data)
                notifyService.success({hideLoader: true})
                this.isSubmitted = false
              })
              .catch(e => {
                this.isSubmitted = false
                console.log(e)
              })
          }
        }
      },
      onHandleModalEvaluation () {
        this.modalEvaluationVisible = !this.modalEvaluationVisible
      },
      editEvaluation (item) {
        const evaluation = cloneDeep(item)
        const criterias = cloneDeep(this.dependencies.criterias)
        criterias.forEach(item => {
          this.$set(item, 'checked', evaluation.criterias.some(field => field.criteria_id === item.id))
        })
        evaluation.criterias.splice(0)
        evaluation.criterias = criterias
        this.evaluation = evaluation
        this.onHandleModalEvaluation()
      },
      saveEvaluation (evaluation) {
        this.isSubmitted = true
        const data = cloneDeep(evaluation)
        data.event_id = this.event.id
        data.start_datetime = this.dateTimeFormat(data.start_datetime, 'en')
        if (data.start_datetime.length === 0) {
          delete data.start_datetime
        }
        data.end_datetime = this.dateTimeFormat(data.end_datetime, 'en')
        if (data.end_datetime.length === 0) {
          delete data.end_datetime
        }
        return restfulService.save('event_paper_type_evaluation_type', null, null, data)
      },
      onSaveEvaluation () {
        bus.$emit('show-loader')
        const data = cloneDeep(this.evaluation)
        this.saveEvaluation(data)
          .then(response => {
            this.loadData(this.event.id)
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.onHandleModalEvaluation()
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.isSubmitted = false
            bus.$emit('show-loader')
            console.log(e)
          })
      },
      removeEvaluation (evaluation, index) {
        restfulService.destroy('event_paper_type_evaluation_type', null, evaluation.id)
          .then(_ => {
            this.eventPaperTypes[index].evaluation_types = this.eventPaperTypes[index].evaluation_types.filter(item => item.id !== evaluation.id)
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">
        <div class="header-flex">
            <h2>Tipos de Trabalhos</h2>
        </div>
        <el-tabs type="card" v-model="activePaperType">
            <el-tab-pane v-for="(paperType, paperTypeIndex) in eventPaperTypes"
                         :label="paperType.paper_type.name"
                         :name="'tab_'+paperType.id">

                <el-form ref="formSelectPaperType"
                         label-position="top">
                    <el-form-item label="Adicionar Avaliação">
                        <el-select v-model="evaluationSelect"
                                   filterable
                                   clearable
                                   @change="selectEvaluation(evaluationSelect, paperTypeIndex)"
                                   placeholder="Selecione uma avaliação"
                                   empty-text="Nenhum registro encontrado"
                                   class="el-select-full">
                            <el-option
                                    v-for="item in dependencies.evaluation_types"
                                    :key="item.id"
                                    :disabled="checkEvaluationSelected(item.id, paperTypeIndex)"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <h3>Tipos de Avaliação</h3>
                <table class="custom-table-list paper-types-table">
                    <thead>
                    <tr>
                        <th>Avaliação</th>
                        <th>Período de Avaliação</th>
                        <th>Critérios</th>
                        <th width="130">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="evaluation in paperType.evaluation_types">
                        <td>{{evaluation.evaluation_type.name}}</td>
                        <td>
                            <div><strong>Início:</strong> {{evaluation.start_datetime | dateTimeEnToBr}}</div>
                            <div><strong>Término:</strong> {{evaluation.end_datetime | dateTimeEnToBr}}</div>
                        </td>
                        <td>
                            <ul>
                                <li v-for="evaluationCriteria in evaluation.criterias">
                                    {{evaluationCriteria.criteria.name}}
                                </li>
                            </ul>
                        </td>
                        <td class="buttons">
                            <el-button type="info"
                                       class="edit-paper-type"
                                       @click="editEvaluation(evaluation)"
                                       title="Editar Tipo de Trabalho">
                                <i class="fa fa-edit"></i>
                            </el-button>
                            <el-button type="danger"
                                       @click="removeEvaluation(evaluation, paperTypeIndex)"
                                       title="Remover Tipo de Trabalho">
                                <i class="fa fa-times"></i>
                            </el-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
        </el-tabs>
        <el-dialog :title="'Dados da avaliação: ' + evaluation.evaluation_type.name"
                   top="5vh"
                   v-if="modalEvaluationVisible"
                   :visible.sync="modalEvaluationVisible">
            <el-form ref="formEvaluation"
                     class="form-paper-type"
                     label-position="top">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Data/Hora Início da Avaliação"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.evaluation.start_datetime.$error }">
                            <el-date-picker
                                    v-model="evaluation.start_datetime"
                                    type="datetime"
                                    format="dd/MM/yyyy HH:mm"
                                    placeholder="Data/Hora Início"
                                    @input="$v.evaluation.start_datetime.$touch()"/>
                            <validation-message
                                    v-if="!$v.evaluation.start_datetime.required && $v.evaluation.start_datetime.$dirty"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Data/Hora Término da Avaliação"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.evaluation.end_datetime.$error }">
                            <el-date-picker
                                    v-model="evaluation.end_datetime"
                                    type="datetime"
                                    format="dd/MM/yyyy HH:mm"
                                    placeholder="Data/Hora Término"
                                    @input="$v.evaluation.end_datetime.$touch()"/>
                            <validation-message
                                    v-if="!$v.evaluation.end_datetime.required && $v.evaluation.end_datetime.$dirty"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Nº Mínimo de avaliações">
                            <el-input-number v-model="evaluation.min_evaluations_number"
                                             :min="0"
                                             :step="1"
                                             :max="100"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Nota Mínima para Aprovação">
                            <el-input-number v-model="evaluation.min_evaluation_next_step"
                                             :min="0"
                                             :step="0.1"
                                             :max="10"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <h3>Critérios de Avaliação</h3>
                <div class="fields-check">
                    <div class="item"
                         v-for="criteria in evaluation.criterias"
                         @click="criteria.checked = !criteria.checked"
                         v-bind:class="{'-checked' : criteria.checked}">
                        <div class="name">{{criteria.name}}</div>
                        <div class="description">{{criteria.description}}</div>
                        <div class="size" v-if="criteria.type === 'number'">
                            Nota Mínima: {{criteria.min_size}} / Nota Máxima: {{criteria.max_size}}
                        </div>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="submit"
                           type="primary"
                           :disabled="$v.evaluation.$invalid"
                           @click="onSaveEvaluation">
                    Salvar Alterações
                </el-button>
                <el-button @click="onHandleModalEvaluation">Fechar</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<style lang="scss">
    .edit-paper-type {
        margin-bottom: 8px;
    }

    .paper-types-table {
        .buttons {
            text-align: center;
            .el-button {
                display: inline-block;
                margin: 5px 0;
            }
        }
    }

    .form-paper-type {
        .el-form-item {
            border: 1px solid #e1e1e1;
            padding: 10px;
            border-radius: 4px;

            &.el-form-item--error {
                padding-bottom: 28px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Evaluations.vue?b49ee132